import {
	Button, Grid, Modal, Typography 
} from '@mui/material';
import Swal from 'sweetalert2';
import { PopupButton } from '@typeform/embed-react';
import './index.css';
import QbraidLogo from '../../assets/images/qbraid_full_logo.png';
import { axiosClient } from '../../utils/axiosClient';
import LoginSurveyImage from '../../assets/images/LogInSurvey.jpg';

function NewUserSurvey({ isNewUser, setGetUserData, userDetails }) {
	const confirmNewUser = () => {
		axiosClient()
			.put('/api/user/confirm', { user: userDetails._id })
			.then(() => setGetUserData(false))
			.catch(() => {
				setGetUserData(false);
				Swal.fire('Sorry, something went wrong.');
			});
	};

	return (
		<Modal
			open={isNewUser}
			onClose={() => setGetUserData(false)}
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '1em'
			}}
		>
			<Grid container className="modal_outer_container">
				<Grid item xs={12} className="modal_right_container">
					<Grid container gap={5}>
						<Grid item xs={12} mb="1rem">
							<img src={QbraidLogo} alt="qBraid Logo" className="right_logo" />
						</Grid>
						<Grid item xs={12}>
							<img
								src={LoginSurveyImage}
								alt="Login Survey"
								className="login_survey_image"
							/>
						</Grid>
						<Grid item xs={12}>
							<PopupButton
								id="isFZcxiJ"
								className="form_button"
								onSubmit={() => confirmNewUser()}
							>
								Take the survey
							</PopupButton>
						</Grid>
						<Grid item xs={12}>
							<Typography className="right_sub_2">
								Welcome to qBraid, help us tailor your quantum computing
								experience by taking our survey.
							</Typography>
						</Grid>

						<Grid item xs={12} container className="skip_section">
							<Grid item>
								<Button
									color="secondary"
									fullWidth
									size="small"
									onClick={() => confirmNewUser(true)}
									className="skip_button"
									cy-data="skip-survey-button"
								>
									Skip
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Modal>
	);
}

export default NewUserSurvey;
